import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { syncPublicCanonicalLink } from '../../lib/public-page-canonical';

interface PublicCanonicalLinkProps {
  origin?: string;
}

export default function PublicCanonicalLink({ origin }: PublicCanonicalLinkProps) {
  const location = useLocation();

  useEffect(() => {
    syncPublicCanonicalLink(
      location.pathname,
      origin ?? (typeof window === 'undefined' ? '' : window.location.origin),
    );
  }, [location.pathname, origin]);

  return null;
}
